export default "__VITE_ASSET__6bea09d4__"